import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import sunastro from '../assets/zodiacSign/sunastro.png';
import baba from "../assets/rootimg/sadhubaba.png";
import { API_END_POINT } from './Utils/Constant';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Queryform = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({
        success: false,
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhoneChange = (value) => {
        setFormData(prev => ({
            ...prev,
            phone: value
        }));
    };

    const queryhandleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus({ success: false, message: '' });

        try {
            const response = await axios.post(`${API_END_POINT}query/create`, formData);
            if (response.data.success) {
                setSubmitStatus({
                    success: true,
                    message: 'Your query has been submitted successfully! We will get back to you soon.'
                });
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            }
        } catch (error) {
            setSubmitStatus({
                success: false,
                message: error.response?.data?.message || 'Failed to submit query. Please try again.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="w-full min-h-fit">
            <div className="max-w-5xl mx-auto px-4 py-16">
                {/* Main Banner Section */}
                <div className="bg-white border-b-4 border-secondary rounded-2xl shadow-2xl overflow-hidden">
                    <div className="flex flex-col md:flex-row items-center">

                        {/* Left Content */}
                        <div className="hidden md:flex md:w-1/2 bg-secondary/40 p-8 md:p-12 items-center justify-center">
                            <div className="relative">
                                <div className="absolute inset-0 opacity-50"></div>
                                <img 
                                    src={baba} 
                                    alt="Spiritual Guide" 
                                    className="max-w-md w-full h-auto relative z-10 transform hover:scale-105 transition-transform duration-300"
                                />
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="w-full md:w-1/2 p-8 md:p-12">
                            <div className="max-w-lg mx-auto">
                                <h1 className="text-xl font-bold  text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md text-center py-2 px-6 mb-6  md:text-left">
                                    ANALYZE YOUR KUNDLI AND GET YOUR FUTURE PREDICTIONS 
                                </h1>
                                <div className="flex items-center mb-8">
                                    <img src={sunastro} alt="sunastro.png" className="w-12 h-12 mr-4" />
                                    <p className="text-xl text-gray-700">
                                        Get deep <span className="font-semibold">insights</span> into your personality, 
                                        <span className="font-semibold"> relationships</span>, luck and destiny
                                    </p>
                                </div>
                                <div className="space-y-4 mb-8">
                                    <div className="flex items-center">
                                        <div className="text-secondary text-2xl mr-3">★</div>
                                        <p className="text-lg text-gray-800">Connect with your spiritual guidance</p>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="text-secondary text-2xl mr-3">★</div>
                                        <p className="text-lg text-gray-800">Explore revelations about your true self</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => navigate('/comming-soon')}
                                    className="w-full bg-gray-900 text-white text-xl font-bold py-2 px-6 rounded-full hover:bg-secondary transition transform hover:scale-105 shadow-lg"
                                >
                                    Get Your Paid Kundli Report Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Optional: Additional Content Section */}
                <div className="mt-12 text-center">
                    <p className="text-sm text-gray-600">
                        Based on Vedic birth chart analysis and ancient wisdom
                    </p>
                </div>

                {/* Query form section */}
                <div className="mt-8 bg-gray-50 rounded-xl shadow-lg p-6 max-w-5xl mx-auto">
                    <h2 className="text-xl font-bold text-secondary mb-4 text-center">Get in touch with us</h2>
                    {submitStatus.message && (
                        <div className={`mb-4 p-4 rounded-md ${submitStatus.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {submitStatus.message}
                        </div>
                    )}
                    <form onSubmit={queryhandleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div className="space-y-1">
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Your Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                    placeholder="Enter your name"
                                />
                            </div>
                            
                            <div className="space-y-1">
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                    placeholder="Enter your email"
                                />
                            </div>

                            <div className="space-y-1">
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
                                <div className="relative w-full overflow-hidden">
                                    <PhoneInput
                                        country={'us'}
                                        value={formData.phone}
                                        onChange={handlePhoneChange}
                                        enableSearch
                                        disableDropdown={false}
                                        disableCountryCode={false}
                                        placeholder="Enter your phone number"
                                        required
                                        containerClass="w-full box-border" // Ensures the container respects the parent width
                                        inputClass="w-full border border-gray-300 rounded-md box-border" // Ensures the input respects the parent width
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div className="space-y-1">
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Query</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                placeholder="Type your question here..."
                            ></textarea>
                        </div>
                        
                        <div className="flex justify-center">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-secondary text-white w-full py-2 rounded-md font-semibold hover:bg-gray-900 transform transition duration-200 shadow-md ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                {isSubmitting ? 'Submitting...' : 'Submit Query'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Queryform;
